import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const partner = {
  armadaList: (partnerId, params) => {
    const url = api.armada.list(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  armadaDetail: (partnerId, vehicleId) => {
    const url = api.armada.detail(partnerId, vehicleId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  armadaHistory: (partnerId, vehicleId, params) => {
    const url = api.armada.history(partnerId, vehicleId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  deleteArmada: (partnerId, vehicleId) => {
    const url = api.armada.detail(partnerId, vehicleId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  addNewArmada: (partnerId, payloads) => {
    const url = api.armada.list(partnerId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  partnerArmada: (partnerId, params) => {
    const url = api.armada.partner(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createPartnerArmada: (partnerId, payloads) => {
    const url = api.armada.partner(partnerId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  partnerArmadaDetail: (partnerId, vehiclePartnerId) => {
    const url = api.armada.partnerDetail(partnerId, vehiclePartnerId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  partnerVehicle: (partnerId, vehiclePartnerId, params) => {
    const url = api.armada.partnerVehicle(partnerId, vehiclePartnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  deletePartner: (partnerId, vehiclePartnerId) => {
    const url = api.armada.partnerDetail(partnerId, vehiclePartnerId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}
export default partner
